import { TbCoins } from "react-icons/tb";

import { Fragment } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { formatUnits } from "viem";

import { ValidatorBasicInfo } from "entities/validator";
import { Validator } from "shared/api/cosmos/use-validators-query";
import { Button } from "shared/ui/button";
import { formatCurrency } from "shared/web3/utils";

import { Cell } from "../table/cell";

type Props = {
  disabled?: boolean;
  index: number;
  validator: Validator;
};

export const Row = (props: Props) => {
  const { validator, index } = props;

  const formattedShares = validator.delegator_shares
    ? formatCurrency(
        formatUnits(BigInt(parseInt(validator.delegator_shares)), 18)
      )
    : "0";

  const formattedCommission =
    parseFloat(validator.commission?.commission_rates?.rate ?? "0") * 100;

  return (
    <Fragment>
      <Cell className="px-0">{index}</Cell>
      <Cell className="justify-start">
        <ValidatorBasicInfo
          description={
            <span
              className={twMerge(
                validator.jailed ? "text-basketBallOrange" : "text-parisGreen",
                "text-xs"
              )}
            >
              {validator.jailed ? "Inactive" : "Active"}
            </span>
          }
          imageUrl={""}
          imgBadge={<TbCoins className="text-parisGreen" />}
          link={validator.description?.website}
          name={validator.description?.moniker || "unknown"}
        />
      </Cell>
      <Cell>{formattedShares} GNET</Cell>
      <Cell>{formattedShares} GNET</Cell>
      <Cell>{formattedCommission} %</Cell>
      <Cell>
        <Button disabled>Delegated</Button>
      </Cell>
    </Fragment>
  );
};
